import { getOrganizationEndpoints } from '@coveo/headless';
import { ProductRecommendationEngine, buildProductRecommendationEngine } from '@coveo/headless/product-recommendation';
import { useVSFContext } from '@vue-storefront/core';
import { useCoveoStore } from '~/stores/coveo-store';

export const useCoveoHeadless = <T extends { refresh: () => void }>(options, buildFunction) => {
  const context = useVSFContext();
  const coveoStore = useCoveoStore();

  const coveoStoreToken = coveoStore.getAuthToken;

  let engine: ProductRecommendationEngine | null = null;
  let productRecommendationsList: T | null = null;

  if (!engine) {
    engine = buildProductRecommendationEngine({configuration: {
        organizationId: context.$config.coveoEnv,
        organizationEndpoints: getOrganizationEndpoints(context.$config.coveoEnv),
        accessToken: coveoStoreToken,
        searchHub: `${context.i18n.localeProperties.coveoSearchHub}_PR`,
        renewAccessToken: () => coveoStore.renewAccessToken(context),
        locale: context.i18n.localeProperties.languageCode,
      }});
  }

  if (productRecommendationsList === null) {
    productRecommendationsList = buildFunction(engine, { options });
    productRecommendationsList.refresh();
  }

  return {
    productRecommendationsList,
    engine
  };
};
